import { useCallback } from 'react';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import type { Params, SendMessageResult } from './api';
import { createDecisionMakerMessage } from './api';

/**
 * Returns a caller that sends the reviewed message to the decision maker. It never rejects — every
 * failure comes back as `{ status: 'failed', retryable }` so the caller can decide between a retry
 * and a dead end.
 */
export function useCreateDecisionMakerMessage(): (params: Params) => Promise<SendMessageResult> {
	const utilityContext = useUtilityContext();

	return useCallback(async (params: Params) => createDecisionMakerMessage(params, utilityContext), [utilityContext]);
}
